module.exports = __webpack_public_path__ + "static/contactImage-f8d3fc7129daed12a132225bf05ff22d.png";